export default __webpack_public_path__ + "static/media/logo-small.3c480b2b.png";